import { render, staticRenderFns } from "./EditorFields.vue?vue&type=template&id=1571e2f0&"
import script from "./EditorFields.vue?vue&type=script&lang=ts&"
export * from "./EditorFields.vue?vue&type=script&lang=ts&"
import style0 from "./EditorFields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports